/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */

import { ISettingGroupDefinition } from "@nuance/hierarchical-settings-ui-domain";
import { IMainFrameViewModel } from "../Mainframe/MainframeViewModel";
import { CmdBuilder, IViewModel } from "@nuance/hap-components";

/**
 * StartView state
 */
export interface IStartViewState {
    showCreateDefDialog: boolean;
    errorImportMessage: string;
    settingDefinition?: ISettingGroupDefinition;
    parentVM: IMainFrameViewModel;
}

/**
 * StartView commands
 */
export class StartViewCommands {
    constructor() {
        const cb = new CmdBuilder();
        const cmds = {
            cancelCreateDefinitionDialog: cb.bindCmdNP(this.cancelCreateDefDialogHandler),
            showCreateDefinitionDialog: cb.bindCmdNP(this.showCreateDefDialogHandler)
        };

        this.Cmds = cmds;
        this.Reducer = cb.buildReducer(cmds);
    }

    readonly Cmds;
    readonly Reducer;

    /**
     * Handles canceling the Create Definition dialog
     * @param state
     * @returns
     */
    cancelCreateDefDialogHandler = (state: IStartViewState) => {
        state.showCreateDefDialog = false;
        state.errorImportMessage = "";
        return state;
    };

    /**
     * Handles showing the Create Definition dialog
     * @param state
     * @returns
     */
    showCreateDefDialogHandler = (state: IStartViewState) => {
        state.showCreateDefDialog = true;
        state.errorImportMessage = "";
        return state;
    };
}

type IStartViewCmds = StartViewCommands["Cmds"];

/**
 * StartView view model interface
 */
export type IStartViewViewModel = IViewModel<IStartViewState, IStartViewCmds>;
